module.exports = __webpack_public_path__ + "img/2015009.4c9d6ffa.svg";